import gql from 'graphql-tag';

export default gql`
  fragment salesforceCampaignFragment on SalesforceCampaign {
    id
    name
  }
`;
